module.exports = __webpack_public_path__ + "img/x-black.b3970bf2.svg";